// extracted by mini-css-extract-plugin
export default {"FeatureBlockIcon":"FeatureBlockIcon_FeatureBlockIcon__8FVK0","hatchimg":"FeatureBlockIcon_hatchimg__UC+51"};